// extracted by mini-css-extract-plugin
module.exports = {"intervalsContainer":"AddCalendarIntervalsModal_intervalsContainer__1PYAG"};